//libs
import * as React from 'react';
import IconButton from '@material-ui/core/IconButton';
import ViewHeadline from '@markinson/uicomponents-v2/SvgIcons/ViewHeadline';
import { withStyles, StyledComponentProps } from '@material-ui/core/styles';
import { Operation } from 'utils/operations';
import classNames from 'classnames';
import TextField from '@markinson/uicomponents-v2/TextFieldV1';
import { isNull } from 'utils/utils';
import FormViewModal from '../Modals/FormViewModal';
import NewDocumentOutputDialog from 'components/NewDocumentOutputDialog';
import { IActionItem } from '../Modals/FormViewModal.properties';

//src
interface IDocumentOutputFieldProps extends StyledComponentProps {
    name?: string;
    operationMode?: Operation;
    sort?: boolean;
    disabled?: boolean;
    bypassPopup?: boolean;
    readOnly?: boolean;
    documentType: string;
    fieldId: string;
    comment?: string;
    params?: any;
    input?: any;
    style?: any;
    size?: string;
    fieldValue?: string;
    value?: string;
    label?: string;
    placeholder?: string;
    overrideDefaultModal?: boolean;
    isProcessing?: boolean;
    additionalDialogProps?: IDocumentOutputAdditionalDialogProps;
    onChange(data: any): void;
    onOpen?(): void;
    onCancelDialog?(): void;
    onApplySettings?(): boolean;
}

interface IDocumentOutputFieldState {
    openDialog: boolean;
}

interface IDocumentOutputAdditionalDialogProps {
    title: string;
    content: any;
    contentProps?: any;
    contentStyle?: any;
    actions: any;
    onCancel?(): void;
    onApply?(data: any): boolean | void;
}

const styles = {
    container: {
        display: 'flex',
        alignItems: 'flex-end',
        paddingBottom: '16px',
        flex: 1
    },
    button: {
        borderRadius: '5px',
        border: '2px solid gray',
        padding: '3px',
        margin: '0px 5px'
    },
    disabled: {
        color: '#555555',
        backgroundColor: '#EEEEEE',
        cursor: 'default',
    },
    dialog: {
        maxWidth: 'unset',
        maxHeight: 'unset'
    },
    dialogContent: {
        'padding': 'unset',
        '&:first-child': {
            paddingTop: 'unset'
        }
    },
    readOnly: {
        'pointer-events': 'none',
        'color': '#555555',
        'backgroundColor': '#EEEEEE',
    }
};

class DocOutputButton extends React.Component<IDocumentOutputFieldProps, IDocumentOutputFieldState> {

    constructor(props: IDocumentOutputFieldProps) {
        super(props);
        this.state = { openDialog: false };
    }

    componentDidUpdate(prevProps: IDocumentOutputFieldProps): void {
        const { onChange, fieldValue } = this.props;

        if (prevProps.fieldValue !== fieldValue) {
            if (onChange) onChange(fieldValue);
        }
    }

    componentDidMount(): void {
        const { bypassPopup } = this.props;

        if (bypassPopup) {
            this.handleModalVisibility(bypassPopup);
        }
    }

    handleModalVisibility = (open: boolean) => {
        const { onOpen } = this.props;

        if (open) {
            if (onOpen) {
                onOpen();
            }
        }
        this.setState({ openDialog: open });
    }

    onCancel = () => {
        const { onCancelDialog, bypassPopup } = this.props;
        this.handleModalVisibility(false);
        if (bypassPopup && onCancelDialog) {
            onCancelDialog();
        }
    }

    defaultModalActions = (): IActionItem[] => {
        const { overrideDefaultModal = false, additionalDialogProps } = this.props;

        return [
            {
                title: 'Ok',
                disabled: false,
                listener: async () => {
                    if (overrideDefaultModal && additionalDialogProps?.onApply) {
                        if (additionalDialogProps?.onApply({})) {
                            this.handleModalVisibility(false);
                        }
                    }

                    return;
                }
            },
            {
                title: 'Cancel',
                isDefault: true,
                listener: () => {
                    if (overrideDefaultModal && additionalDialogProps?.onCancel) {
                        additionalDialogProps?.onCancel();
                    }
                    this.onCancel();

                    return;
                }
            }
        ];
    };

    render(): React.ReactNode {

        const {
            classes, readOnly, name, size, documentType, fieldId,
            disabled, params = {}, comment = '', style, fieldValue = '', value, overrideDefaultModal = false, additionalDialogProps, isProcessing = false,
        } = this.props;
        const { openDialog } = this.state;
        const textFieldValue = !isNull(fieldValue) ? fieldValue : value;
        const ReadOnly = typeof(readOnly) === 'object' ? (readOnly as any)?.Value : readOnly;

        return (
            <div key={name} className={classes.container}>
                <NewDocumentOutputDialog
                    open={openDialog && !overrideDefaultModal}
                    comment={comment}
                    documentType={documentType}
                    fieldId={fieldId}
                    customerId={params.CustomerId || null}
                    supplierId={params.Supplier || null}
                    onApply={async () => {
                        const { onApplySettings, bypassPopup } = this.props;
                        if (bypassPopup && onApplySettings) {
                            const response = await onApplySettings();
                            if (response) {
                                this.handleModalVisibility(!response);
                            }
                        } else {
                            this.handleModalVisibility(false);
                        }
                    }}
                    onCancel={this.onCancel}
                    isProcessing={isProcessing}
                />
                {
                    overrideDefaultModal && <FormViewModal
                        {...additionalDialogProps?.contentProps}
                        open={openDialog && overrideDefaultModal}
                        loading={false}
                        title={additionalDialogProps?.title}
                        modalContent={additionalDialogProps?.content}
                        actions={additionalDialogProps?.actions || this.defaultModalActions()}
                        style={additionalDialogProps?.contentStyle}
                        dialogActionsButtons={true}
                        dialogActionsShadow={false}
                    />
                }

                <TextField
                    name={name}
                    disabled={true}
                    title={textFieldValue}
                    value={textFieldValue}
                    size={size}
                    style={{
                        display: 'inline-block',
                        padding: 'unset',
                        ...style
                    }}
                />
                <IconButton
                    disableRipple
                    disabled={disabled || ReadOnly}
                    className={classNames(classes.button, { [classes.readOnly]: ReadOnly || disabled })}
                    onClick={() => { this.handleModalVisibility(true); }}>
                    <ViewHeadline />
                </IconButton>
            </div>
        );
    }
}

export default withStyles(styles, { index: 1 })(DocOutputButton);
